var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4FD"
    },
    d: "M72.449,365.783h356.66c0.103-0.091,0.207-0.183,0.298-0.284 c22.954-25.592,28.688-63.719,22.066-97.758c-5.466-28.098-20.016-56.013-44.845-69.348 c-39.09-20.994-89.183-0.082-130.153-16.928c-30.77-12.652-50.992-44.508-81.848-56.939c-24.005-9.67-52.348-5.821-74.155,8.267 c-10.152,6.558-18.959,15.143-26.531,24.665c-12.329,15.504-21.751,34.892-19.804,54.765 c1.349,13.769,7.963,26.324,12.378,39.406c4.415,13.083,6.402,28.424-0.909,40.076c-5.335,8.503-14.768,13.596-20.297,21.97 c-9.803,14.848-4.443,35.509,5.699,50.117C71.472,364.46,71.954,365.124,72.449,365.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4FD"
    },
    d: "M103.417,362.604h296.841c0.086-0.076,0.172-0.152,0.248-0.236 c19.104-21.3,23.876-53.032,18.365-81.362c-4.549-23.386-16.659-46.619-37.323-57.717 c-32.534-17.473-74.225-0.069-108.324-14.089c-25.609-10.53-42.439-37.043-68.12-47.389c-19.979-8.049-43.568-4.845-61.718,6.88 c-8.449,5.458-15.779,12.603-22.081,20.528c-10.262,12.903-18.103,29.04-16.482,45.58c1.123,11.46,6.627,21.909,10.302,32.797 c3.675,10.889,5.328,23.657-0.756,33.354c-4.44,7.077-12.291,11.316-16.892,18.285c-8.159,12.358-3.698,29.553,4.743,41.711 C102.604,361.503,103.005,362.056,103.417,362.604z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4FD"
    },
    d: "M426.936,427.057H86.063c-7.429,0-13.508-6.079-13.508-13.508v-34.983 c0-7.43,6.079-13.508,13.508-13.508h340.873c7.43,0,13.508,6.079,13.508,13.508v34.983 C440.444,420.979,434.365,427.057,426.936,427.057z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.69
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.555,
    y: 374.626,
    style: {
      fill: "#0D2436"
    },
    width: 367.889,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.555,
    y: 395.558,
    style: {
      fill: "#0D2436"
    },
    width: 367.889,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.555,
    y: 416.489,
    style: {
      fill: "#0D2436"
    },
    width: 367.889,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21425A"
    },
    d: "M183.232,370.482l-39.075-107.89l-4.3,2.625L178.42,371.98 C180.024,371.478,181.628,370.979,183.232,370.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21425A"
    },
    d: "M149.305,380.929l30.574-125.993l-6.014-1.616l-31.58,129.587 C144.63,382.266,146.97,381.606,149.305,380.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.704,
    y: 269.782,
    transform: "matrix(0.9996 0.029 -0.029 0.9996 8.0702 -7.0422)",
    style: {
      fill: "#21425A"
    },
    width: 232.487,
    height: 10.142
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#21425A"
    },
    points: "362.995,283.291 407.943,267.423 408.237,257.286 363.289,273.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "130.9,266.415 175.847,250.547 408.237,257.286 363.289,273.153  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21425A"
    },
    d: "M409.516,378.646l-38.519-106.355l-4.3,2.625l38.201,105.762 C406.44,380.006,407.979,379.328,409.516,378.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21425A"
    },
    d: "M375.657,392.639l31.062-128.003l-6.014-1.616L368.47,395.293 C370.874,394.428,373.268,393.541,375.657,392.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5377"
    },
    d: "M231.649,240.665H181.74c-3.565,0-6.482,2.917-6.482,6.482s2.917,6.482,6.482,6.482h49.909 V240.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.649,244.218h-47.254c-3.376,0-6.137,1.318-6.137,2.929c0,1.611,2.762,2.929,6.137,2.929 h47.254V244.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M231.649,228.665H181.74c-3.565,0-6.482,2.917-6.482,6.482s2.917,6.482,6.482,6.482h49.909 V228.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.649,232.218h-47.254c-3.376,0-6.137,1.318-6.137,2.929c0,1.611,2.762,2.929,6.137,2.929 h47.254V232.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M362.238,243.449l-120.392-3.536c-5.413-0.159-9.132-4.816-8.276-10.337l11.882-76.716 c0.826-5.334,5.845-9.648,11.165-9.597l118.267,1.122c5.593,0.053,9.617,4.576,8.928,10.063l-9.908,78.958 C373.19,239.091,367.935,243.616,362.238,243.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.948,221.708l7.505-58.886c0.609-4.779-2.873-8.728-7.728-8.783L262.73,152.86 c-4.648-0.053-9.027,3.711-9.741,8.374l-8.788,57.431L365.948,221.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF4FD"
    },
    d: "M365.948,221.708l7.505-58.886c0.609-4.779-2.873-8.728-7.728-8.783L262.73,152.86 c-4.648-0.053-9.027,3.711-9.741,8.374l-8.788,57.431L365.948,221.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315,148.752c-0.121,0.864-0.927,1.558-1.8,1.548c-0.873-0.01-1.481-0.718-1.359-1.581 c0.122-0.864,0.927-1.556,1.799-1.547C314.512,147.18,315.121,147.888,315,148.752z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "362.969,217.524 316.027,216.39 324.039,158.354 370.48,158.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF5377"
    },
    points: "324.039,158.354 344.028,176.051 370.48,158.93  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#0D2436"
    },
    d: "M357.47,188.118l-29.937-0.548c-0.616-0.011-1.051-0.522-0.967-1.135l0,0 c0.084-0.613,0.656-1.105,1.271-1.094l29.925,0.534c0.623,0.011,1.068,0.525,0.988,1.141l0,0 C358.669,187.634,358.094,188.129,357.47,188.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#0D2436"
    },
    d: "M357.032,191.485l-29.956-0.568c-0.616-0.012-1.052-0.523-0.968-1.137l0,0 c0.084-0.614,0.656-1.106,1.272-1.095l29.944,0.555c0.624,0.012,1.068,0.526,0.988,1.144l0,0 C358.232,191.001,357.656,191.497,357.032,191.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#0D2436"
    },
    d: "M355.146,205.971l-30.035-0.657c-0.618-0.014-1.054-0.53-0.97-1.147l0,0 c0.084-0.617,0.659-1.111,1.276-1.098l30.023,0.643c0.625,0.013,1.071,0.533,0.99,1.154l0,0 C356.35,205.488,355.772,205.985,355.146,205.971z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FEC329",
      strokeMiterlimit: 10
    },
    points: "323.896,160.127 344.165,178.046 370.329,160.531  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M352.228,174.985c-0.085,0.644-3.346,0.721-3.614,1.299c-0.277,0.599,2.001,2.63,1.566,3.126 c-0.44,0.501-2.905-1.323-3.465-0.963c-0.555,0.356-0.088,3.464-0.723,3.649c-0.613,0.179-1.336-2.847-1.987-2.857 c-0.65-0.011-2.174,2.975-2.735,2.776c-0.582-0.206,0.707-3.281,0.251-3.654c-0.461-0.376-3.39,1.355-3.693,0.843 c-0.3-0.507,2.497-2.451,2.381-3.055c-0.112-0.583-3.324-0.762-3.237-1.404c0.087-0.642,3.332-0.72,3.599-1.296 c0.277-0.597-1.984-2.616-1.551-3.109c0.438-0.498,2.887,1.312,3.446,0.952c0.553-0.356,0.091-3.444,0.723-3.63 c0.61-0.179,1.331,2.827,1.98,2.837c0.649,0.01,2.168-2.966,2.729-2.77c0.582,0.203-0.703,3.269-0.245,3.64 c0.462,0.375,3.393-1.358,3.699-0.847c0.303,0.505-2.498,2.452-2.38,3.056C349.086,174.163,352.313,174.342,352.228,174.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M347.453,174.512c-0.233,1.756-1.862,3.158-3.637,3.129 c-1.774-0.029-3.02-1.475-2.785-3.229c0.235-1.753,1.86-3.151,3.632-3.125C346.436,171.314,347.686,172.757,347.453,174.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M258.911,196.492l-3.34,3.837c-0.552,0.634-0.598,1.56-0.117,2.249 c1.823,2.608,6.568,8.735,12.173,10.759c0.685,0.247,1.452,0.064,1.952-0.465l3.363-3.564c0.699-0.741,0.656-1.912-0.096-2.6 l-11.326-10.364C260.763,195.651,259.584,195.718,258.911,196.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M256.474,195.482l6.862,10.828c0.219,0.346,0.549,0.608,0.935,0.744l11.034,3.888 c1.63,0.574,3.071-1.227,2.154-2.691l-6.58-10.497c-0.213-0.34-0.533-0.601-0.909-0.741l-11.317-4.218 C257.015,192.183,255.538,194.005,256.474,195.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M267.69,201.771c-0.203,0.283-0.74,0.246-1.2-0.083c-0.46-0.329-0.669-0.826-0.467-1.109 c0.203-0.283,0.74-0.246,1.2,0.083C267.684,200.992,267.893,201.488,267.69,201.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M286.395,197.233c-0.579,1.081-0.529,2.257-0.34,3.153c0.069,0.327,0.036,0.668-0.081,0.982 c-0.685,1.852-1.861,3.585-3.891,4.072c-2.27,0.544-4.079-1.077-5.698-2.406c-2.816-2.311-5.932-3.522-9.569-2.444 c-0.555,0.165-0.319,1.035,0.24,0.87c2.911-0.863,5.659-0.185,8.017,1.664c1.375,1.078,2.667,2.396,4.342,3.007 c3.347,1.221,5.863-1.12,7.159-3.931c0.14-0.304,0.364-0.563,0.645-0.745c1.25-0.807,1.991-1.689,2.41-2.537 C290.659,196.838,287.491,195.187,286.395,197.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M293.031,186.066l4.395,2.563c0.726,0.423,1.644,0.295,2.231-0.306 c2.221-2.279,7.35-8.087,8.29-13.972c0.115-0.719-0.209-1.438-0.823-1.83l-4.131-2.636c-0.859-0.548-2.001-0.287-2.536,0.58 l-8.06,13.066C291.859,184.404,292.145,185.549,293.031,186.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M292.495,188.649l9.352-8.768c0.299-0.28,0.495-0.653,0.556-1.058l1.753-11.567 c0.259-1.708-1.78-2.787-3.047-1.612l-9.08,8.429c-0.294,0.273-0.49,0.636-0.558,1.032l-2.025,11.906 C289.154,188.735,291.219,189.845,292.495,188.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M296.573,176.454c0.316,0.146,0.38,0.681,0.143,1.194c-0.237,0.514-0.686,0.812-1.002,0.666 c-0.316-0.146-0.38-0.681-0.143-1.194C295.809,176.606,296.257,176.308,296.573,176.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M288.614,158.929c1.17,0.366,2.316,0.097,3.161-0.256c0.309-0.129,0.65-0.16,0.98-0.105 c1.948,0.326,3.87,1.157,4.728,3.06c0.96,2.128-0.294,4.209-1.296,6.048c-1.743,3.199-2.349,6.487-0.609,9.857 c0.266,0.514,1.076,0.119,0.809-0.398c-1.393-2.698-1.241-5.524,0.133-8.187c0.801-1.553,1.854-3.068,2.141-4.828 c0.573-3.516-2.198-5.55-5.202-6.296c-0.325-0.081-0.622-0.252-0.852-0.494c-1.027-1.077-2.032-1.639-2.943-1.893 C287.428,154.815,286.399,158.236,288.614,158.929z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M277.761,174.589l1.417-2.675c0.234-0.442,0.135-0.985-0.237-1.319 c-1.409-1.265-4.987-4.174-8.509-4.589c-0.43-0.051-0.85,0.159-1.068,0.534l-1.467,2.52c-0.305,0.524-0.122,1.197,0.407,1.493 l7.965,4.475C276.801,175.326,277.475,175.128,277.761,174.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M279.309,174.844l-5.441-5.347c-0.174-0.171-0.4-0.278-0.643-0.305l-6.92-0.761 c-1.022-0.112-1.614,1.126-0.884,1.851l5.232,5.194c0.17,0.168,0.39,0.276,0.627,0.307l7.128,0.914 C279.442,176.829,280.051,175.574,279.309,174.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M271.959,172.716c0.079-0.192,0.395-0.243,0.707-0.114c0.311,0.128,0.499,0.388,0.42,0.579 c-0.079,0.192-0.396,0.243-0.707,0.114C272.068,173.167,271.88,172.908,271.959,172.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M261.733,177.875c0.189-0.705,0.001-1.38-0.229-1.873c-0.084-0.18-0.111-0.382-0.086-0.58 c0.146-1.166,0.594-2.329,1.704-2.886c1.242-0.622,2.51,0.073,3.628,0.624c1.944,0.958,3.914,1.239,5.876,0.122 c0.3-0.17,0.045-0.643-0.256-0.471c-1.57,0.894-3.254,0.872-4.871,0.12c-0.943-0.439-1.87-1.028-2.923-1.156 c-2.105-0.255-3.246,1.442-3.617,3.246c-0.04,0.195-0.135,0.376-0.273,0.519c-0.615,0.637-0.925,1.248-1.054,1.796 C259.316,178.681,261.375,179.209,261.733,177.875z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M300.051,199.031l-3.004,0.376c-0.496,0.062-0.884,0.454-0.944,0.951 c-0.227,1.88-0.554,6.48,1.128,9.602c0.206,0.382,0.618,0.605,1.05,0.568l2.906-0.246c0.604-0.051,1.05-0.587,0.989-1.191 l-0.91-9.09C301.206,199.393,300.657,198.955,300.051,199.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M299.372,197.616l-1.254,7.525c-0.04,0.24,0.002,0.488,0.119,0.701l3.35,6.103 c0.495,0.901,1.849,0.675,2.023-0.339l1.248-7.266c0.041-0.235,0.002-0.478-0.109-0.689l-3.344-6.361 C300.92,196.368,299.543,196.59,299.372,197.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M301.849,204.856c-0.202,0.045-0.426-0.185-0.499-0.513c-0.074-0.329,0.031-0.632,0.233-0.677 c0.202-0.045,0.426,0.184,0.499,0.513C302.156,204.508,302.051,204.811,301.849,204.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M311.944,210.266c-0.686,0.25-1.13,0.791-1.402,1.263c-0.099,0.173-0.25,0.311-0.426,0.404 c-1.039,0.549-2.248,0.851-3.341,0.262c-1.223-0.659-1.381-2.096-1.572-3.328c-0.332-2.142-1.233-3.916-3.273-4.881 c-0.311-0.147-0.552,0.333-0.239,0.481c1.633,0.772,2.582,2.164,2.895,3.919c0.182,1.024,0.232,2.121,0.732,3.056 c0.999,1.87,3.044,1.83,4.734,1.098c0.183-0.079,0.385-0.105,0.582-0.074c0.875,0.138,1.553,0.041,2.076-0.168 C313.992,211.783,313.242,209.794,311.944,210.266z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M284.895,239.219l-2.563,17.085h32.462l3.417-19.648 C318.21,236.657,284.04,229.822,284.895,239.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M328.443,256.924c-0.091,2.593-13.543,4.227-30.045,3.648 c-16.503-0.578-29.807-3.149-29.716-5.743c0.091-2.593,13.543-4.227,30.045-3.648C315.23,251.76,328.534,254.331,328.443,256.924 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M361.367,241.363l-125.283-4.146l0.029-0.883l125.268,4.146 c0.367-0.001,9.349-0.137,11.031-10.229l9.712-80.349l0.876,0.105l-9.715,80.369 C371.477,241.238,361.468,241.363,361.367,241.363z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.645,259.775c-7.039,0-12.999-0.608-17.602-1.332c-10.187-1.604-16.13-4.117-16.189-4.142 l0.347-0.812c0.234,0.1,23.631,9.853,58.403,2.897l0.172,0.866C319.443,259.118,310.961,259.775,303.645,259.775z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.961,
    y: 162.735,
    transform: "matrix(0.0288 -0.9996 0.9996 0.0288 71.5978 521.9708)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.884,
    height: 122.812
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0D2436"
    },
    points: "258.754,264.989 196.3,263.481 212.689,255.997 268.134,256.683  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.885,263.589L202.52,262.4l11.536-5.429l48.975,0.676L255.885,263.589z M203.233,262.255 l52.402,1.155l6.817-5.632l-48.304-0.676L203.233,262.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "260.642,259.253 211.214,258.457 211.496,258.324 260.818,259.107  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "258.082,261.367 207.111,260.393 207.414,260.25 258.271,261.21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "209.207,262.518 208.811,262.509 219.482,257.214 219.849,257.219  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "213.999,262.625 213.597,262.616 223.909,257.276 224.281,257.281  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "218.859,262.733 218.452,262.724 228.395,257.339 228.771,257.345  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "223.791,262.842 223.377,262.833 232.94,257.403 233.321,257.408  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "228.796,262.953 228.376,262.944 237.545,257.468 237.932,257.473  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "233.874,263.066 233.448,263.057 242.213,257.533 242.604,257.539  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "239.028,263.181 238.596,263.171 246.943,257.6 247.34,257.605  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "244.26,263.297 243.821,263.288 251.738,257.667 252.141,257.673  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "249.571,263.415 249.125,263.405 256.599,257.736 257.007,257.741  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M345.992,267.111c-4.305,2.485-8.99,2.43-10.464-0.124c-1.474-2.554,0.82-6.639,5.125-9.124 c4.305-2.485,8.99-2.43,10.464,0.124C352.591,260.541,350.297,264.626,345.992,267.111z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.59
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344,260.873c-0.091,0-0.183-0.025-0.265-0.076c-0.234-0.145-0.306-0.454-0.159-0.688 c0.115-0.185,2.852-4.521,5.435-3.258c0.248,0.12,0.352,0.42,0.23,0.668c-0.119,0.248-0.421,0.354-0.668,0.23 c-1.745-0.851-4.126,2.851-4.15,2.889C344.329,260.79,344.166,260.873,344,260.873z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M145.852,76.596l-8.669,9.959c-1.432,1.645-1.552,4.049-0.303,5.836 c4.732,6.77,17.048,22.671,31.595,27.926c1.778,0.642,3.769,0.167,5.066-1.208l8.728-9.252c1.815-1.924,1.703-4.961-0.248-6.747 l-29.396-26.899C150.66,74.414,147.6,74.587,145.852,76.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M139.529,73.974l17.811,28.104c0.569,0.898,1.424,1.579,2.427,1.932l28.639,10.091 c4.23,1.491,7.971-3.185,5.589-6.985L176.918,79.87c-0.554-0.883-1.383-1.559-2.36-1.923l-29.372-10.949 C140.932,65.412,137.098,70.139,139.529,73.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M168.64,90.298c-0.526,0.735-1.92,0.639-3.115-0.216c-1.195-0.854-1.737-2.143-1.211-2.878 c0.526-0.735,1.92-0.639,3.115,0.216C168.623,88.274,169.165,89.563,168.64,90.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M217.188,78.519c-1.503,2.805-1.373,5.859-0.882,8.184c0.179,0.85,0.092,1.734-0.209,2.549 c-1.778,4.807-4.829,9.305-10.099,10.569c-5.892,1.413-10.587-2.796-14.79-6.244c-7.31-5.998-15.398-9.141-24.836-6.343 c-1.441,0.427-0.827,2.687,0.622,2.257c7.555-2.24,14.687-0.48,20.809,4.318c3.57,2.798,6.922,6.219,11.268,7.805 c8.687,3.17,15.218-2.907,18.58-10.203c0.363-0.788,0.946-1.463,1.675-1.933c3.245-2.095,5.167-4.383,6.256-6.585 C228.255,77.494,220.032,73.209,217.188,78.519z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0A4243",
      strokeMiterlimit: 10
    },
    d: "M299.446,326.699"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0A4243",
      strokeMiterlimit: 10
    },
    d: "M314.269,284.57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0A4243",
      strokeMiterlimit: 10
    },
    d: "M314.269,283.79"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EAF4FD"
    },
    cx: 149.5,
    cy: 409.873,
    rx: 59,
    ry: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FEC329"
    },
    cx: 167.386,
    cy: 313.907,
    rx: 52.661,
    ry: 17.944
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M150.613,408.306L150.613,408.306c-2.145,0-3.901-1.755-3.901-3.901v-88.158 c0-2.145,1.755-3.901,3.901-3.901l0,0c2.146,0,3.901,1.755,3.901,3.901v88.158 C154.513,406.551,152.758,408.306,150.613,408.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M186.987,397.967l-80.433,22.337c-2.274,0.632-4.651-0.712-5.283-2.986l0,0 c-0.632-2.274,0.712-4.651,2.986-5.283l80.433-22.337c2.274-0.632,4.651,0.712,5.283,2.986l0,0 C190.605,394.959,189.261,397.336,186.987,397.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC329"
    },
    d: "M190.096,421.508l-79.182-26.432c-2.239-0.747-3.459-3.19-2.711-5.429l0,0 c0.747-2.239,3.19-3.459,5.429-2.711l79.182,26.432c2.238,0.747,3.459,3.19,2.711,5.429l0,0 C194.777,421.035,192.335,422.255,190.096,421.508z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9834 -0.1813 0.1813 0.9834 -44.7997 26.2133)",
    style: {
      fill: "#FEC329"
    },
    cx: 120.967,
    cy: 258.126,
    rx: 30.426,
    ry: 47.98
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M96.327,232.833c0,0-8.302,55.338,26.141,71.235"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M115.809,311.102c0,0,4.194,12.225,29.052,16.064 "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EAF4FD"
    },
    cx: 394.657,
    cy: 402.764,
    rx: 37,
    ry: 9.407
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#118C8B"
    },
    d: "M396.103,347.784c0.06-1.965-3.684-1.551-5.044-2.971c-1.36-1.42-2.08-3.647-1.187-5.398 c1.17-2.292,4.512-2.906,5.465-5.297c1.462-3.671-3.825-6.52-4.707-10.372c-1.237-5.401,6.331-8.962,7.175-14.438 c0.742-4.813-3.988-9.238-3.185-14.041c0.726-4.346,5.581-6.804,7.21-10.899c1.372-3.45,0.21-7.316,0.023-11.023 c-0.188-3.707,1.456-8.254,5.144-8.678c3.761-0.432,6.411,3.844,6.715,7.617c0.304,3.773-0.673,7.693,0.498,11.293 c1.577,4.848,6.797,8.26,7.083,13.349c0.279,4.967-4.384,9.35-3.669,14.273c0.747,5.144,7.122,8.652,6.505,13.812 c-0.347,2.9-2.825,4.984-4.812,7.124c-1.987,2.141-3.669,5.344-2.182,7.857c0.674,1.139,1.866,1.855,2.79,2.803 c2.25,2.309,2.704,6.165,1.051,8.933c-1.653,2.768-5.263,4.197-8.363,3.31C412.613,355.042,395.948,352.902,396.103,347.784z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.68
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C5B9"
    },
    d: "M406.151,351.283c3.593-20.264,1.664-77.213,1.644-77.786l0.944-0.033 c0.019,0.574,1.952,57.622-1.658,77.985L406.151,351.283z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C5B9"
    },
    d: "M375.558,346.487c-0.509-2.119-4.392-0.584-6.261-1.707c-1.868-1.122-3.289-3.294-2.844-5.428 c0.583-2.793,3.978-4.424,4.3-7.259c0.493-4.353-5.992-5.858-8.059-9.72c-2.898-5.415,4.158-11.432,3.464-17.534 c-0.61-5.364-6.959-8.717-7.501-14.088c-0.491-4.86,3.986-8.904,4.533-13.759c0.461-4.09-1.908-7.886-3.19-11.796 c-1.282-3.911-0.85-9.253,2.971-10.781c3.896-1.558,7.978,2.242,9.403,6.189c1.426,3.947,1.524,8.424,3.826,11.933 c3.1,4.725,9.678,6.852,11.468,12.212c1.747,5.231-1.962,11.279,0.238,16.336c2.299,5.283,10.14,7.176,10.985,12.876 c0.475,3.203-1.568,6.154-3.069,9.023c-1.501,2.869-2.366,6.785-0.042,9.04c1.053,1.022,2.537,1.44,3.802,2.185 c3.08,1.813,4.69,5.805,3.729,9.248c-0.961,3.443-4.405,6.024-7.979,5.979C395.332,349.434,376.885,352.006,375.558,346.487z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.68
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#118C8B"
    },
    d: "M387.324,347.298c-2.066-22.721-20.736-83.068-20.924-83.674l1-0.311 c0.188,0.608,18.891,61.059,20.967,83.891L387.324,347.298z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5377"
    },
    d: "M367.869,343.586v46.953c0,8.519,8.841,15.489,19.646,15.489h16.371 c10.805,0,19.645-6.97,19.645-15.489v-46.953H367.869z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.869,
    y: 354.937,
    style: {
      fill: "#FF5377"
    },
    width: 55.662,
    height: 7.225
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5377"
    },
    d: "M57.115,411.233c7.072-12.472,11.679-26.337,13.476-40.562c0.765-6.057,1.794-13.331,7.364-15.833 c5.172-2.323,10.93,1.011,16.08,3.384c8.916,4.108,19.08,5.457,28.759,3.815c4.591-0.778,9.1-2.213,13.755-2.32 c4.655-0.107,9.704,1.418,12.294,5.288c2.577,3.85,2.106,8.916,1.359,13.488c-2.584,15.833-7.286,31.318-13.941,45.915 c-2.689,5.899-6.274,12.17-12.426,14.214c-2.794,0.929-5.809,0.856-8.751,0.745c-14.759-0.556-29.491-1.816-44.13-3.775 c-6.041-0.809-12.389-1.873-17.105-5.734c-4.717-3.861-6.914-11.472-3.009-16.153L57.115,411.233z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.26
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M83.863,426.508c10.239,1.776,21.106,3.943,30.994,0.381c2.983-1.074,5.954-3.197,8.574-6.057 c2.379-2.597,4.697-6.597,6.52-10.788c3.786-8.702,6.925-20.663,7.56-30.886c0.395-6.352,0.406-12.902,0.801-19.401 c-0.59-0.039-1.18-0.052-1.763-0.038c-4.655,0.107-9.164,1.541-13.755,2.32c-9.679,1.641-19.843,0.293-28.759-3.815 c-5.149-2.373-10.908-5.707-16.08-3.384c-5.57,2.501-6.599,9.775-7.364,15.833c-1.797,14.225-6.403,28.089-13.476,40.562 l-6.098,2.403C59.569,421.918,72.469,424.532,83.863,426.508z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M135.946,389.986l10.277,5.605l0.479-0.877l-10.356-5.649l-0.079-0.044l-14.963-2.108 c3.458-9.239,6.291-18.383,7.297-25.585l-0.99-0.139c-1.003,7.187-3.849,16.338-7.317,25.581l-21.006-2.959 c3.411-8.817,6.108-16.854,6.719-21.547l-0.992-0.129c-0.599,4.61-3.324,12.671-6.763,21.53l-17.148-2.415 c4.629-12.352,8.081-23.059,8.407-24.077l-0.953-0.305c-0.082,0.255-3.671,11.393-8.489,24.236l-10.736-1.512l-0.139,0.99 l10.514,1.481c-2.832,7.504-6.058,15.501-9.234,22.204l-9.46-1.771l-0.183,0.982l9.197,1.723 c-3.619,7.508-7.144,13.217-9.911,14.444l-0.227,0.1l-0.058,0.24c-0.09,0.375-2.18,9.229,0.533,13.563l0.848-0.531 c-2.264-3.615-0.767-11.16-0.46-12.569c2.953-1.525,6.592-7.428,10.277-15.058l16.801,3.147 c-4.252,9.621-7.636,16.815-7.724,17.001l-0.048,11.511h1v-11.186c0.54-1.147,3.8-8.093,7.799-17.134l20.535,3.846 c-4.47,9.685-8.005,16.539-8.095,16.713l-0.994,8.647l0.994,0.111l0.931-8.381c0.428-0.832,3.883-7.584,8.176-16.9l16.517,3.094 l9.149,8.986l0.701-0.713l-9.258-9.094l-0.108-0.107l-16.57-3.103c3.246-7.082,6.917-15.531,10.106-23.955L135.946,389.986z  M71.475,404.457c3.215-6.768,6.444-14.766,9.266-22.246l17.135,2.414c-3.016,7.703-6.528,15.93-9.631,22.973L71.475,404.457z  M109.823,411.638l-20.551-3.849c3.117-7.069,6.63-15.302,9.641-23.019l21.016,2.96 C116.735,396.147,113.061,404.584,109.823,411.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M107.497,182.225c0,0,1.023,8.959,5.948,7.989l1.842-0.487l-4.59-11.056 C110.696,178.671,105.828,178.501,107.497,182.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA98"
    },
    d: "M182.466,159.734l4.674-9.353c0.969-1.52,3.542-5.571,3.723-6.032 c0.224-0.569-0.271-1.035-0.271-1.035c-1.1-0.984-4.307,4.517-4.749,5.29c-0.113-0.099-0.23-0.198-0.352-0.297 c1.464-2.51,4.241-7.293,4.462-7.868c0.302-0.783-0.292-1.284-0.292-1.284c-1.305-1.034-5.424,6.528-6.091,7.777 c-0.222-0.143-0.446-0.284-0.672-0.423c1.385-2.796,4.369-8.846,4.592-9.528c0.291-0.891-0.339-1.346-0.339-1.346 c-1.506-1.011-6.191,9.497-6.191,9.497c-0.03,0.072-0.057,0.141-0.082,0.21c-0.256-0.14-0.504-0.273-0.739-0.398 c0.991-2.652,3.017-8.111,3.141-8.731c0.164-0.823-0.506-1.216-0.506-1.216c-1.593-0.868-4.741,8.887-4.741,8.887l-3.54,4.891 c-0.458-0.203-0.822-0.785-0.891-2.061c-0.133-2.477-0.623-2.568-0.623-2.568c-2.316-0.273-1.689,3.855-1.827,7.547 c-0.104,2.769,1.291,4.938,1.996,5.849c0.21,0.327,0.393,0.468,0.393,0.468l-1.9,3.847l7.633,3.669L182.466,159.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA98"
    },
    d: "M57.412,181.186l-6.137-8.465c-1.204-1.341-4.403-4.918-4.657-5.344 c-0.314-0.525,0.098-1.065,0.098-1.065c0.925-1.15,4.986,3.754,5.548,4.444c0.095-0.116,0.195-0.233,0.299-0.351 c-1.854-2.237-5.374-6.503-5.686-7.034c-0.426-0.723,0.078-1.315,0.078-1.315c1.119-1.233,6.416,5.556,7.279,6.68 c0.195-0.177,0.394-0.353,0.594-0.527c-1.823-2.533-5.754-8.014-6.085-8.651c-0.433-0.831,0.114-1.383,0.114-1.383 c1.321-1.243,7.658,8.36,7.658,8.36c0.041,0.066,0.079,0.13,0.115,0.193c0.23-0.18,0.453-0.352,0.665-0.513 c-1.41-2.455-4.3-7.51-4.524-8.102c-0.296-0.785,0.301-1.282,0.301-1.282c1.43-1.116,6.128,7.995,6.128,7.995l4.291,4.248 c0.418-0.275,0.683-0.908,0.543-2.179c-0.273-2.465,0.196-2.635,0.196-2.635c2.24-0.647,2.295,3.528,3.034,7.148 c0.554,2.715-0.468,5.082-1.014,6.096c-0.154,0.357-0.311,0.526-0.311,0.526l2.502,3.486l-6.933,4.865L57.412,181.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA98"
    },
    d: "M110.104,181.853c0,0,8.415,18.423,8.082,26.372c0,0,17.319-0.346,20.689-4.033 c0,0-3.123-18.633-6.025-25.2C129.948,172.425,108.654,172.604,110.104,181.853z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M139.601,154.188c-3.32-8.222-11.962-13.383-21.098-11.951c-10.642,1.668-17.916,11.647-16.248,22.289 c0.687,4.383,2.786,8.193,5.759,11.044c4.757,7.734,10.96,17.528,10.96,17.528s21.702-2.612,24.951-7.07 C143.925,186.028,140.074,154.163,139.601,154.188z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible",
      fill: "#FFAA98"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000088103009260210830580000010515324110878452620_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000088103009260210830580000010515324110878452620_)",
      fill: "#0D2436"
    },
    d: "M136.474,161.296 c-0.176-0.674-0.065-1.337,0.184-1.961c0.261-0.616,0.72-1.204,1.379-1.586c0.648-0.397,1.504-0.496,2.187-0.275 c0.7,0.191,1.24,0.645,1.592,1.222c-0.697,0.076-1.246,0.048-1.721,0.161c-0.474,0.073-0.827,0.215-1.18,0.424 C138.194,159.682,137.493,160.422,136.474,161.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000088103009260210830580000010515324110878452620_)",
      fill: "#0D2436"
    },
    d: "M135.358,154.32 c0.246-0.611,0.716-1.027,1.212-1.35c0.506-0.314,1.07-0.514,1.648-0.609c0.579-0.082,1.171-0.077,1.741,0.064 c0.569,0.138,1.119,0.381,1.596,0.817c-0.585,0.296-1.101,0.43-1.604,0.572c-0.502,0.119-0.978,0.228-1.459,0.292 c-0.479,0.077-0.958,0.132-1.463,0.171C136.517,154.309,136.001,154.331,135.358,154.32z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA98"
    },
    d: "M107.233,173.616c0,0-3.037-4.262-4.866-0.817c-1.829,3.445,6.781,12.343,9.896,9.89 C112.263,182.69,111.041,177.758,107.233,173.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M127.202,163.034c-1.773-0.654-3.338-1.156-4.691-0.854c-0.669,0.153-1.333,0.437-1.985,0.918 c-0.335,0.22-0.642,0.513-0.999,0.77c-0.323,0.296-0.646,0.605-1.052,0.892c0.06-0.473,0.198-0.928,0.342-1.392 c0.226-0.416,0.414-0.88,0.736-1.262c0.595-0.798,1.541-1.434,2.61-1.657c1.077-0.226,2.186,0.023,3.049,0.513 C126.076,161.465,126.792,162.153,127.202,163.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.29,
      fill: "#FF5377"
    },
    d: "M118.973,193.098l22.039-10.177l2.912,3.108 C143.925,186.028,141.567,191.136,118.973,193.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M134.181,159.127c1.075,1.324,2.059,2.703,2.988,4.116c0.935,1.41,1.817,2.851,2.657,4.319 l0.191,0.334l-0.3,0.202c-0.724,0.487-1.46,0.957-2.207,1.412c-0.745,0.457-1.509,0.888-2.287,1.299 c0.643-0.601,1.299-1.183,1.975-1.738c0.674-0.557,1.359-1.1,2.055-1.625l-0.109,0.536c-0.928-1.414-1.813-2.854-2.646-4.326 C135.658,162.187,134.873,160.685,134.181,159.127z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.29,
      fill: "#FF5377"
    },
    points: "135.993,170.688 140.496,169.192 139.484,167.772  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M123.293,156.418c-2.061,0.364-3.776,0.948-5.477,1.708c-0.835,0.406-1.67,0.825-2.501,1.311 c-0.427,0.226-0.833,0.494-1.275,0.732c-0.435,0.249-0.854,0.527-1.351,0.749c0.207-0.487,0.473-0.941,0.76-1.384 c0.327-0.402,0.631-0.846,1.021-1.199c0.747-0.748,1.643-1.35,2.61-1.813c0.98-0.437,2.04-0.714,3.114-0.762 C121.26,155.723,122.363,155.869,123.293,156.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5377"
    },
    d: "M140.33,173.167l0.725,4.624c0,0-5.924,2.508-8.191-1.875L140.33,173.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M115.941,148.561c0,0,20.114,2.375,23.772-4.516c0,0,4.187-8.553-2.341-9.899l-1.708,4.216 c0,0,0.333-7.949-3.52-7.345c-3.854,0.604-3.129,5.229-3.129,5.229s-19.056-5.7-25.527,13.477l-2.146-3.612l0.725,4.624 l-3.854,0.604l2.554,1.179c0,0-5.608,9.566,1.599,20.281c0,0,3.239-4.423,7.211,3.23c0,0,4.38,5.22,2.763-0.055 C110.725,170.7,102.959,151.385,115.941,148.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D716E"
    },
    d: "M128.768,267.878l38.228-10.142c0,0,3.144,9.362,12.483,16.383c0,0-12.857,7.154-11.522,18.79 c0,0-20.738-9.428-34.321,2.274C133.636,295.184,119.43,284.262,128.768,267.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M107.455,207.803c0,0-17.584,2.997-39.418-34.201c-3.912,3.569-8.029,6.926-12.079,10.383 c11.599,22.526,33.012,53.144,56.884,52.342C112.841,236.327,120.717,219.505,107.455,207.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M142.246,203.457c0,0,16.344-8.193,28.606-49.546c4.654,2.525,9.457,4.795,14.219,7.179 c-5.85,24.653-19.283,59.517-42.648,64.472C142.423,225.561,132.182,218.002,142.246,203.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M195.862,356.036c-8.485-3.811-16.165-9.252-23.094-15.418 c-11.466-10.204-21.085-22.436-29.377-35.311c-3.884-6.03-7.589-12.245-10.721-18.705c1.318-0.484,3.132,6.46,0,0 c15.213-6.631,30.036-10.532,45.095-16.579l64.127,18.92C241.891,288.942,245.792,322.489,195.862,356.036"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067AD1"
    },
    d: "M132.675,293.723c0,0,15.597-19.603,33.541-4.78l45.249,31.986c0,0,2.34,12.483-13.263,12.483 C198.202,333.411,143.603,314.106,132.675,293.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067AD1"
    },
    d: "M146.314,283.756c0,0,14.679-22.83,35.378-12.189l51.045,21.565c0,0,4.957,11.693-10.285,15.031 C222.452,308.163,161.35,301.329,146.314,283.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067AD1"
    },
    d: "M185.751,323.561c0,0,9.33,19.212,70.183,28.574l5.461-12.483l-65.533-28.086 C195.862,311.567,181.102,316.831,185.751,323.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067AD1"
    },
    d: "M212.579,302.424c0,0-1.013,14.266,60.462,10.883l4.016-11.211L220,288.603 C220,288.603,206.643,296.797,212.579,302.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA98"
    },
    d: "M255.934,352.135c0,0,10.922,4.681,14.823,3.901c3.901-0.78,14.043-25.745,10.142-31.986 c0,0-9.362,14.043-19.504,15.603L255.934,352.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M283.239,323.269c-2.34-3.901-13.263,0.78-14.823,10.922c0,0,2.122,2.342,6.794,3.775 c-11.963,26.476-6.794,23.531-6.794,23.531c8.337-5.306,11.519-21.652,11.694-22.58c0.094,0.009,0.18,0.023,0.275,0.031 C280.385,338.948,285.58,327.17,283.239,323.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA98"
    },
    d: "M270.757,313.539c0,0,10.922,4.681,14.823,3.901c3.901-0.78,14.043-25.745,10.142-31.986 c0,0-9.362,14.043-19.504,15.603L270.757,313.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M109.221,209.569l25.612,74.187c0,0,39.375-13.086,43.276-18.547c0,0-21.255-62.084-21.255-63.644 s-15.229-1.004-15.229-1.004l-21.561,4.882L109.221,209.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M114.335,202.735l9.362-2.34c0,0,13.263,108.442,92.839,130.286c0,0-30.426,9.362-20.284,24.965 c0,0-74.115-21.064-78.796-81.136l-14.417-66.707L114.335,202.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M136.96,199.614c0,0,15.603,100.64,98.3,98.3l7.021-9.362c0,0-66.748-16.865-86.252-94.88 L136.96,199.614z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.019,
    y: 226.608,
    transform: "matrix(0.9855 -0.1699 0.1699 0.9855 -37.7737 21.792)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.884,
    height: 10.058
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.381,
    y: 182.321,
    transform: "matrix(0.7489 -0.6627 0.6627 0.7489 -104.9549 88.5577)",
    style: {
      fill: "#FFFFFF"
    },
    width: 15.98,
    height: 0.882
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.206,
    y: 154.875,
    transform: "matrix(0.4648 -0.8854 0.8854 0.4648 -49.4254 243.4225)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.883,
    height: 15.441
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M210.418,333.071c-37.083-5.576-59.468-41.003-71.717-69.741 c-13.246-31.078-17.815-61.234-17.859-61.535l0.873-0.129c0.045,0.3,4.6,30.36,17.806,61.334 c12.16,28.524,34.354,63.683,71.029,69.198L210.418,333.071z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M230.035,295.504c-32.574,0-55.038-24.479-68.396-45.713 c-15.304-24.327-22.263-49.742-22.331-49.997l0.852-0.229c0.068,0.253,7,25.558,22.237,49.773 c14.025,22.288,38.165,48.198,73.52,45.018l0.079,0.88C233.975,295.416,231.984,295.504,230.035,295.504z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5377"
    },
    d: "M110.156,179.75c-0.023,0-0.047-0.002-0.07-0.005c-0.199-0.032-4.879-0.81-5.099-3.911 c-0.06-0.843,0.153-1.395,0.63-1.637c1.011-0.511,2.671,0.829,2.994,1.102c0.186,0.158,0.209,0.436,0.052,0.622 c-0.157,0.188-0.436,0.21-0.623,0.053c-0.706-0.597-1.714-1.151-2.024-0.989c-0.091,0.047-0.185,0.28-0.148,0.787 c0.17,2.402,4.314,3.094,4.356,3.1c0.241,0.039,0.405,0.266,0.366,0.506C110.556,179.595,110.369,179.75,110.156,179.75z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0D2436",
      strokeMiterlimit: 10
    },
    d: "M184.248,300.736c0,0-6.581-6.824-12.763-6.824"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D2436"
    },
    d: "M302.737,283.423c-2.092-4.04-13.286-0.052-15.478,9.972c0,0,1.971,2.471,6.544,4.193 c-13.597,25.675-8.254,23.059-8.254,23.059c8.653-4.773,12.853-20.888,13.085-21.803c0.093,0.015,0.178,0.034,0.272,0.048 C298.907,298.893,304.829,287.463,302.737,283.423z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmitted);
export default __webpack_public_path__ + "static/media/admitted.3c71dc57a97bd98d74170c56ed54a3fa.svg";
export { ForwardRef as ReactComponent };